import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RestService } from 'src/app/service/rest.service';
import { SeoService } from 'src/app/service/seo.service';

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.css']
})
export class EventDetailsComponent implements OnInit {
  event_id
  event_data:any = {
    START_DATE : "",
    IMG_PATH : "",
    TITLE : "",
    Place : ""
  }
  constructor(private route: ActivatedRoute , private rest : RestService, private seo : SeoService) { }

  ngOnInit(): void {
    window.scrollTo(0, 0) 
    this.event_id = this.route.snapshot.paramMap.get('id')
    this.getData()
  }

  getData(){
    this.rest.eventDetails(this.event_id).subscribe((res:any) => {
      console.log(res)
      this.event_data = res
      this.setSeo(res)
    })
  }

  // Events carry no free-text body, so build a readable description from the
  // fields the API does return: place and a nicely formatted start date.
  private setSeo(data: any) {
    if (!data) { return }
    const bits = []
    if (data.Place && String(data.Place).trim()) { bits.push(String(data.Place).trim()) }
    const date = this.formatDate(data.START_DATE)
    if (date) { bits.push(date) }
    const description = bits.length
      ? `${data.TITLE} — ${bits.join(' • ')}`
      : data.TITLE
    this.seo.update({ title: data.TITLE, description, image: data.IMG_PATH })
  }

  // Turns the API's ISO start date into an Arabic long date, ignoring anything
  // unparseable so a bad value never leaks into the description.
  private formatDate(raw: any): string {
    if (!raw) { return '' }
    const d = new Date(raw)
    if (isNaN(d.getTime())) { return '' }
    try {
      return d.toLocaleDateString('ar-EG', { year: 'numeric', month: 'long', day: 'numeric' })
    } catch {
      return ''
    }
  }

}
